import req from '../../api/request'
import type {
  TeamPlayerFinderPayload,
  TeamPlayerFinderUpdateBody,
} from '../../features/team/playerFinder/types'

/**
 * SN-4709 × SN-8081 — the Team page's Player Finder settings.
 *
 * The GET is also the Team page's tab probe: 403 only when the caller has no
 * authority on the team at all (callers resolve it to "no tab"); a caller with
 * nothing to manage gets 200 + [].
 *
 * Errors are rethrown untouched. req() throws a 4xx as the parsed JSON body with
 * `status` / `statusCode` attached (and `invalid_fields` on a 422), so a 409 still
 * carries the server's FRESH settings under `data.registrations` — see
 * utils/playerFinderApiError.
 */
export const getTeamPlayerFinderSettings = async (
  teamId: string
): Promise<TeamPlayerFinderPayload> => {
  const response = await req(`/teams/${teamId}/player-finder`)

  return (response as { data: TeamPlayerFinderPayload }).data
}

/**
 * Save ONE registration's settings; returns the refreshed settings for the whole
 * team. Single transport attempt: turning recruiting on publishes an ad, so a
 * committed-but-dropped response must never be re-sent (a re-send would also 409
 * on its own, now stale, revision).
 */
export const updateTeamPlayerFinderRegistration = async (
  teamId: string,
  teamRegistrationId: string,
  body: TeamPlayerFinderUpdateBody
): Promise<TeamPlayerFinderPayload> => {
  const response = await req(
    `/teams/${teamId}/player-finder/registrations/${teamRegistrationId}`,
    {
      method: 'PUT',
      body: JSON.stringify(body),
      transportRetries: 1,
    }
  )

  return (response as { data: TeamPlayerFinderPayload }).data
}
